// cp-search-modal-guard
// ---------------------------------------------------------------------------
// Two small behaviours for the search modal (#modal-1):
//
// 1) Ghost-click fix. MicroModal closes the modal on `touchstart` of the close
//    "X" / overlay backdrop. The modal is dismissed while the finger is down, so
//    the trailing synthetic `click` — hit-tested AFTER the overlay is gone —
//    lands on the header cart icon and sends the user to /cart. preventDefault()
//    on that gesture's `touchend` stops the browser synthesizing that click.
//
//    SCOPING: the overlay (data-micromodal-close) is the ancestor of the whole
//    dialog, so we must NOT use closest('[data-micromodal-close]') — that matches
//    every tap inside the modal and would break caret placement in the input, the
//    results-slider arrows, and the View All button. We only act on the close
//    button itself or a direct backdrop tap (event.target === overlay).
//
// 2) Reset on close. MicroModal only hides the modal; it never clears the field.
//    So the last query (and its results) persist on reopen. On every close we
//    empty the input and hide the result groups for a fresh start next time.
(function () {
  // 1) Ghost-click suppression — scoped to close button / backdrop only.
  document.addEventListener('touchend', function (event) {
    var t = event.target;
    var onCloseButton = t.closest && t.closest('.predictive-search__close');
    var onBackdrop = t.classList && t.classList.contains('modal__overlay--search');
    if (onCloseButton || onBackdrop) {
      event.preventDefault();
    }
  }, { passive: false });

  // 2) Clear the query + results whenever the modal closes.
  var modal = document.getElementById('modal-1');
  if (!modal || !window.MutationObserver) return;

  function resetSearch() {
    var input = document.getElementById('search-input');
    if (input) input.value = '';

    // Hide the three result groups + the "view all" footer + no-results.
    ['predictive-search-product-container',
     'predictive-search-page-container',
     'predictive-search-article-container',
     'predictive-search-no-reuslts'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
    var footer = modal.querySelector('.predictive-search__footer');
    if (footer) footer.style.display = 'none';
  }

  new MutationObserver(function () {
    if (modal.getAttribute('aria-hidden') === 'true') resetSearch();
  }).observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
})();
